import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73873ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "new-chat-container"
}
const _hoisted_2 = { class: "bottom" }
const _hoisted_3 = { class: "groupChat" }
const _hoisted_4 = { class: "groupChatInner" }
const _hoisted_5 = { class: "groupMembers" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }

import MobileNavigationBar from "@/components/layouts/MobileNavigationBar/MobileNavigationBar.vue";
import ProfileAvatar from "@/components/images/ProfileAvatar.vue";
import ChatSidebarSearchBar from "@/components/chat/chatSidebar/ChatSidebarSearchBar.vue";
import NewChatListContainer from "@/components/chat/chatContainer/NewChatListContainer/NewChatListContainer.vue";
import { ProfileAvatarSizeEnum } from "@/types/avatar";
import { IListItem } from "@/types/list";

interface IExtendedListItem {
  key: string;
  title?: string;
  items: IListItem[];
}

interface Props {
  title: string;
  confirmTitle: string;
  lists: IExtendedListItem[];
  listsContainerHeight: string;
  selectedMembers: IListItem[];
  isRecommendationsVisible: boolean;
}

interface Emits {
  (e: "add-selected", member: IListItem): void;
  (e: "remove-selected", member: IListItem): void;
  (e: "confirm"): void;
  (e: "redirect"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectChatWrapper',
  props: {
    title: {},
    confirmTitle: {},
    lists: {},
    listsContainerHeight: {},
    selectedMembers: {},
    isRecommendationsVisible: { type: Boolean }
  },
  emits: ["add-selected", "remove-selected", "confirm", "redirect"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;



const addSelected = (member: IListItem) => {
  emit("add-selected", member);
};
const removeSelected = (member: IListItem) => {
  emit("remove-selected", member);
};
const confirmSelection = () => {
  emit("confirm");
};
const redirect = () => {
  emit("redirect");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MobileNavigationBar, {
      title: _ctx.title,
      "action-title": _ctx.confirmTitle,
      "handle-redirect": redirect,
      "handle-action": confirmSelection,
      "is-action-disabled": !_ctx.selectedMembers.length
    }, null, 8, ["title", "action-title", "is-action-disabled"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ChatSidebarSearchBar),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMembers, (member) => {
              return (_openBlock(), _createElementBlock("div", {
                key: member.itemId,
                class: "member",
                onClick: ($event: any) => (removeSelected(member))
              }, [
                _createVNode(ProfileAvatar, {
                  src: member.pictureSrc,
                  "is-online": false,
                  size: _unref(ProfileAvatarSizeEnum).Medium,
                  "is-delete": true
                }, null, 8, ["src", "size"])
              ], 8, _hoisted_6))
            }), 128))
          ]),
          (_ctx.isRecommendationsVisible)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_ctx.$t("settings.chat.createGroupChat.usersRecommendations")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "lists-container",
        style: _normalizeStyle({ height: _ctx.listsContainerHeight })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lists, (list) => {
          return (_openBlock(), _createBlock(NewChatListContainer, {
            key: list.key,
            "list-items-array": list.items,
            title: list.title,
            onAddMember: addSelected,
            onRemoveMember: removeSelected
          }, null, 8, ["list-items-array", "title"]))
        }), 128))
      ], 4)
    ])
  ], 512))
}
}

})